import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const Ctx = createContext({ count: 0, refresh: async () => {}, addToCart: async () => {} });

export function CartProvider({ children }) {
  const { user, guest } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user || guest) { setCount(0); return; }
    try {
      const r = await api("/cart/count");
      setCount(Number(r?.count || 0));
    } catch { /* silent */ }
  }, [user, guest]);

  useEffect(() => {
    refresh();
    if (!user || guest) return;
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh, user, guest]);

  const addToCart = useCallback(async (product_id, quantity = 1, color, size) => {
    const body = { product_id, quantity };
    if (color) body.color = color;
    if (size) body.size = size;
    // Optimistic: bump the badge instantly, then reconcile with the server.
    setCount((c) => c + Number(quantity || 1));
    try {
      await api("/cart/add", { method: "POST", body: JSON.stringify(body) });
    } catch (e) {
      setCount((c) => Math.max(0, c - Number(quantity || 1)));
      throw e;
    }
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ count, refresh, addToCart }), [count, refresh, addToCart]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCart() { return useContext(Ctx); }
